import {
  mallFeDomainApi,
  mallEntranceApi
  // mallEntranceDomainApi
} from '../request'
import { apiPath } from '../api'

export const memberCouponPack = {
  queryHasPayingOrders: data =>
    mallFeDomainApi.post(apiPath.queryHasPayingOrders, data),
  getCouponPackList: data =>
    mallFeDomainApi.post(apiPath.getCouponPackList, data),
  getCouponPackDetail: data =>
    mallFeDomainApi.post(apiPath.getCouponPackDetail, data),
  getCouponPackAgainPayUrl: data =>
    mallFeDomainApi.post(apiPath.getCouponPackAgainPayUrl, data),
  getCouponPackBuyRecord: data =>
    mallFeDomainApi.post(apiPath.getCouponPackBuyRecord, data),
  getCouponPackPayUrl: data =>
    mallEntranceApi.post(apiPath.getCouponPackPayUrl, data),
  getAgainCouponPackPayUrl: data =>
    mallEntranceApi.post(apiPath.getAgainCouponPackPayUrl, data)
}
